export const isRequestCanceled = (e: any) =>
  e?.name === 'AbortError' ||
  e?.code === 'ERR_CANCELED' ||
  e?.message === 'canceled' ||
  (typeof e?.toJSON === 'function' && e.toJSON()?.name === 'CanceledError');
